<template>
    <div>
        {{ msg }}
    </div>
</template>

<script>
export default {
    name: "GeneralReports",
    data() {
        return {
            msg: 'General Reports Here',
        }
    },
}
</script>

<style scoped>

</style>
